import script from "./TrustedAccountFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrustedAccountFilter.vue?vue&type=script&setup=true&lang=ts"

import "./TrustedAccountFilter.vue?vue&type=style&index=0&id=6c5c1d11&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c5c1d11"]])

export default __exports__